export var MemberPaymentCardWalletFormLoadingState;
(function (MemberPaymentCardWalletFormLoadingState) {
    MemberPaymentCardWalletFormLoadingState["LoadingConnector"] = "LoadingConnector";
    MemberPaymentCardWalletFormLoadingState["AddingCard"] = "AddingCard";
    MemberPaymentCardWalletFormLoadingState["Success"] = "Success";
})(MemberPaymentCardWalletFormLoadingState || (MemberPaymentCardWalletFormLoadingState = {}));
export const defaultMemberPaymentCardWalletFormState = {
    addPaymentCardButtonState: { isDisabled: true },
    termsAndConditionsAccepted: false,
    loadingState: MemberPaymentCardWalletFormLoadingState.LoadingConnector,
    showModal: false,
    makePrimaryChosen: false
};
